// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-new-diary__head__text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #333333;
}
.add-new-diary__head__subtext {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
}
.add-new-diary__card {
  background-color: #ffffff;
  border: 1px solid #f3f5f6;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  margin-top: 40px;
  display: flex;
  margin-bottom: 10px;
}
.add-new-diary__card__left {
  width: 65%;
  border-right: 1px solid #e9e9e9;
}
.add-new-diary__card__right {
  width: 35%;
}
.add-new-diary__basic-info {
  padding: 5%;
}
.add-new-diary__basic-info__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #333333;
}
.add-new-diary__basic-info__title {
  margin-top: 40px;
}
.add-new-diary__basic-info__content {
  margin-top: 40px;
}
.add-new-diary__basic-info__content__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.add-new-diary__basic-info__content__text-area {
  width: 100%;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  resize: none;
  height: 242px;
  padding: 2%;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}
.add-new-diary__basic-info__image-upload {
  margin-top: 30px;
}
.add-new-diary__basic-info__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.add-new-diary__file-upload {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0 auto;
}
.add-new-diary__file-upload__uploader {
  display: inline-block;
  cursor: pointer;
  width: 164px;
  height: 164px;
  padding-top: 50px;
  margin-right: 8px;
  margin-top: 8px;
  background: #f6f6f7;
  border: 1px dashed #c1c1c1;
  border-radius: 8px;
  text-align: center;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #c1c1c1;
}
.add-new-diary__file-upload__uploader input[type=file] {
  display: none;
}
.add-new-diary__file-upload__preview {
  margin-right: 8px;
  margin-top: 8px;
}
.add-new-diary__file-upload__preview img {
  width: 164px;
  height: 164px;
  border-radius: 8px;
}
.add-new-diary__application {
  margin-top: 100px;
  margin-left: 40px;
}
.add-new-diary__application__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.add-new-diary__application__body {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}`, "",{"version":3,"sources":["webpack://./src/components/work-a-diary/add-new-diary/add-new-diary.scss"],"names":[],"mappings":"AAGQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAFZ;AAKQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAHZ;AAOI;EAEI,yBAAA;EACA,yBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AANR;AAQQ;EACI,UAAA;EACA,+BAAA;AANZ;AASQ;EACI,UAAA;AAPZ;AAWI;EACI,WAAA;AATR;AAWQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AATZ;AAYQ;EACI,gBAAA;AAVZ;AAaQ;EACI,gBAAA;AAXZ;AAaY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAXhB;AAcY;EACI,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAbhB;AAiBQ;EACI,gBAAA;AAfZ;AAkBQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAhBZ;AAoBI;EACI,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAlBR;AAoBQ;EACI,qBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EAEA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,kBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AApBZ;AAuBQ;EACI,aAAA;AArBZ;AAwBQ;EACI,iBAAA;EACA,eAAA;AAtBZ;AAwBY;EACI,YAAA;EACA,aAAA;EACA,kBAAA;AAtBhB;AA2BI;EACI,iBAAA;EACA,iBAAA;AAzBR;AA2BQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAzBZ;AA4BQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA1BZ","sourcesContent":[".add-new-diary {\n\n    &__head {\n        &__text {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 28px;\n            line-height: 38px;\n            color: #333333;\n        }\n\n        &__subtext {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            color: #868686;\n        }\n    }\n\n    &__card {\n        // margin: auto;\n        background-color: #ffffff;\n        border: 1px solid #f3f5f6;\n        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n        border-radius: 8px;\n        margin-top: 40px;\n        display: flex;\n        margin-bottom: 10px;\n\n        &__left {\n            width: 65%;\n            border-right: 1px solid #e9e9e9;\n        }\n\n        &__right {\n            width: 35%;\n        }\n    }\n\n    &__basic-info {\n        padding: 5%;\n\n        &__head {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 20px;\n            line-height: 30px;\n            color: #333333;\n        }\n\n        &__title {\n            margin-top: 40px;\n        }\n\n        &__content {\n            margin-top: 40px;\n\n            &__head {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 14px;\n                line-height: 20px;\n                color: #505054;\n            }\n\n            &__text-area {\n                width: 100%;\n                background: #ffffff;\n                border: 1px solid #e9e9e9;\n                border-radius: 8px;\n                resize: none;\n                height: 242px;\n                padding: 2%;\n\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 16px;\n                line-height: 24px;\n                color: #333333;\n            }\n        }\n\n        &__image-upload {\n            margin-top: 30px;\n        }\n\n        &__head {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 20px;\n            color: #505054;\n        }\n    }\n\n    &__file-upload {\n        display: flex;\n        flex-wrap: wrap;\n        list-style: none;\n        margin: 0 auto;\n\n        &__uploader {\n            display: inline-block;\n            cursor: pointer;\n            width: 164px;\n            height: 164px;\n            padding-top: 50px;\n            margin-right: 8px;\n            margin-top: 8px;\n\n            background: #f6f6f7;\n            border: 1px dashed #c1c1c1;\n            border-radius: 8px;\n            text-align: center;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 22px;\n            color: #c1c1c1;\n        }\n\n        &__uploader input[type='file'] {\n            display: none;\n        }\n\n        &__preview {\n            margin-right: 8px;\n            margin-top: 8px;\n            \n            img {\n                width: 164px;\n                height: 164px;\n                border-radius: 8px;\n            }\n        }\n    }\n\n    &__application {\n        margin-top: 100px;\n        margin-left: 40px;\n\n        &__head {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 20px;\n            color: #505054;\n        }\n\n        &__body {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 12px;\n            line-height: 18px;\n            color: #999999;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
